const en: LocaleType = {
  header: 'this is a header',
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Cancel',
  login_button: 'Log in',
  signout: 'Sign Out',
  loading: 'Please wait...',
  read_more: 'Read more',
  general: {
    countryNameFI: 'Finland',
    countryNameSE: 'Sweden',
  },
  auth: {
    successAuth: 'Successfully authenticated. Redirecting to home page',
    processing: 'Processing authentication',
    invalidAuth: 'Invalid session for the user.',
  },
  errors: {
    default: 'Unable to deliver this request.',
    duplicate: 'Data is already in the system.',
    invalidEmail: 'Email is invalid',
    pageNotFound: 'Page not found',
  },
  cookie: {
    message:
      'This site uses cookies to provide you with a great user experience. By continuing to use this website, you consent the use of cookies in accordance with our',
    policy: 'Cookie Policy',
    accept: 'Accept',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hi ${args[0]}, `,
        bookings: 'check your own bookings here',
        check_bookings: 'Check your bookings',
        has_reservation: 'Do you have a reservation already? ',
      },
      menus: {
        home: 'Home',
        parks: 'Parks',
        bestpoint: 'BestPoint -service point',
        why_bestpark: 'Why BestPark?',
        our_story: 'Introduction',
        info: 'Info',
        for_host: 'For the Hosts',
        the_cities: 'For the Cities',
        contact_us: 'Contact us',
        login: 'Log in',
        language: (...args: string[]) => `${args[0]}`,
      },
      all_parks: 'All Parks',
      buy_tickets: 'Buy tickets',
      buy: 'Buy',
      make_reservation: 'Book now',
      for_host: 'For the Hosts',
      demonstration: 'Introduction',
      the_cities: 'For the Cities',
      the_press: 'For the Press',
    },
    footer: {
      follow: 'Follow Us:',
      contact: 'Contact',
      quick_links: 'Quick Links',
      traveling: 'Traveling with you',
      other_links: 'Other Links',
      privacy_statement: 'Privacy Statement',
      terms_of_delivery: 'Terms of Delivery',
      see_map: 'See locations in the map',
      travel: 'Traveling together with you',
      privacy: 'Privacy Statement',
      media: 'For the Press',
    },
    hero: {
      title: 'Best way to stay!',
      text: 'We are opening the first six parks for the 2020 summer season.',
      view_parks: 'View the parks',
    },
  },
  park_info: {
    header: 'Select your arrival date from the calendar',
    amenities: (...args: string[]) =>
      `${args[0]} spaces and ${args[1]} amenities:`,
    faq: 'Frequently asked questions',
    extras: {
      area: 'Region',
      forWhom: 'For whom',
      thingsToDo: 'Things to do and see',
    },
    intro: 'Introduction',
  },
  reservation: {
    noReservation: 'No Reservations',
    continue: 'Continue',
    previous: 'Previous',
    loading: 'Please wait...',
    slots: {
      header: 'How many nights are you staying for?',
      arrival: (...args: string[]) => `You are arriving on ${args[0]}.`,
      comment: (...args: string[]) =>
        `As the next weekend is sold out the maximum nights per stay can be ${args[0]}.`,
      choose: 'Choose Parking Slot',
      chooseTitle: 'Choose your Parking Slot',
      unavailable: 'unavailable',
      regularSlots: 'Regular slots',
      price: (...args: string[]) => `(Price ${args[0]} ${args[1]}/night)`,
      addPrice: (...args: string[]) => `(Price +${args[0]} ${args[1]}/night)`,
      slotError: (...args: string[]) =>
        `Slot ${args[0]} is no longer available. Select a new one.`,
    },
    coupon: {
      validateCoupon: 'Validate',
      couponCode: 'Coupon code',
      couponInvalid: 'Coupon invalid',
      couponApplied: 'Coupon applied',
      couponDiscount: 'Coupon discount',
      couponExpired: 'This coupon has already expired',
      invalidPark: 'This coupon is not valid for the selected park',
      limitExceeded: 'This coupon has reached its limit number of usage',
      userLimitExceeded: 'You have previously used this coupon',
      shortNights:
        'This coupon is not valid for the selected numbers of nights',
      exceedingNights:
        'This coupon is not valid for the selected numbers of nights',
    },
    registration: {
      header: 'Your contact details',
      subheader: 'Existing BestPark account?',
      login: 'Log in here',
      loginNote: 'Log in here',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      phoneInfo: '(in international format, e.g. +358401234567)',
      email: 'Email',
      street: 'Street',
      postalCode: 'Postal code',
      town: 'Town',
      country: 'Country of Residence',
      license: 'Towing vehicle license plate',
      promos:
        'Sign up for our newsletter and be the first to hear the latest news about BestPark.',
      errors: {
        fillRequired: 'Please fill in highlighted fields.',
        email: 'Email is invalid.',
        phone:
          'Number has to be in international format +358401234567 for example.',
        emailExist: 'Email is already registered.',
        fieldRequired: 'A required field',
      },
      clickHereToReserve: 'Click here to start your reservation',
    },
    payment: {
      header: 'Payment',
      subheader:
        'Please select your payment method to complete your reservation.',
      night: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'nights' : 'night'} in the park`,
      total: 'Total',
      totalInCurrency: (...args: string[]) => `Total price in ${args[0]}`,
      currencyConversionNote: (...args: string[]) =>
        `${args[0]} converted into ${args[1]} for payment`,
      cardPay: 'Pay with credit and debit cards',
      mobilePay: 'Pay with mobile payments',
      collectorBankPay: 'Pay with installments',
      invoicePayment: 'Pay with invoice',
      invoiceNote: (...args: string[]) =>
        `billing surcharge ${args[0]} ${
          Number(args[0]) > 1 ? 'euros' : 'euro'
        }`,
      surcharge: 'Surcharge',
      onlineBankPay: 'Pay with online bank',
      coupon: 'Do you have a coupon code?',
      terms1: 'I have read and understood the',
      terms2: 'terms and conditions.',
      terms3:
        'We will also create an account for you for easier use of your BestPark purchases.',
      pay: (...args: string[]) => `Pay ${args[0]} now`,
      processingPayment: 'Processing reservation payment',
      paymentProcessed: 'Successfully processed payment.',
      paymentError:
        'Something went wrong! Our team will look into this. You may contact support.',
      orderNumber: 'Order number: ',
      failed: 'Payment transaction cancelled',
    },
    card: {
      goToReservation: 'Go to reservation',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'nights' : 'night'}`,
    },
    profile: {
      header: 'Your reservations',
    },
    guestInformation: {
      header: 'Passenger card',
      firstName: 'First name',
      lastName: 'Last name',
      address: 'Address',
      dateOfBirth: 'Date of birth',
      nationality: 'Nationality',
      passportNumber: 'Passport number',
      dateOfArrival: 'Date of arrival',
      countryOfEntry: (...args: string[]) => `Country of entry to ${args[0]}`,
      addChildButton: 'Add family member',
      addPassenger: 'Add another passenger',
      passengerInformation: 'Passenger’s personal data',
      childSpouseInfo: 'Personal details of the family member',
      passportInfo: (...args: string[]) =>
        `Nordic country citizens or passengers residing in ${args[0]} do not fill`,
      companionHeader:
        'Personal data on the spouse and underage children accompanying the passenger.',
      subHeader:
        'Providing incorrect personal data is subject to penalty under the Penal Code.',
      delete: 'Delete',
    },
    ancillary: {
      header: 'Additional Services',
      skip: 'Skip these',
      subheader1: 'Stay on the move while parked!',
      subheader2: 'We have electric scooters and bikes in all parks',
      subheader3: 'Limited amounts per park so reserve yours in advance today!',
      soldOut: 'Sorry, sold out for all days of your stay.',
      soldOutDay: (...args: string[]) =>
        `All ${args[0]} are reserved for this day`,
      price: (...args: string[]) => `${args[0]}€ per day`,
      reservation: 'Choose quantity and dates:',
      max: (...args: string[]) => `Only ${args[0]} available for this day`,
      total: 'Total:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'days' : 'day'
        }`,
      firstDayNote: 'Reservation starts at 13:00 and ends 12:00 next day',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Check-in',
      checkOut: 'Check out',
      info: (...args: string[]) => `
        Check-in time starts at ${args[0]} every day and check-out time is by ${args[1]}`,
      addOns: {
        earlyCheckIn: {
          info: ' Late Check in at 1PM',
          button: (...args: string[]) => `Add for ${args[0]}€`,
        },
        lateCheckOut: {
          info: ' Late Check out at 3PM',
          button: (...args: string[]) => `Add for ${args[0]}€`,
        },
      },
      parking: {
        textSlot: 'slot',
        title: (...args: string[]) => `Your ${args[0]}`,
        slot: (...args: string[]) =>
          `When you arrive to the park your reserved ${args[0]} is number ${args[1]}.`,
      },
      map: {
        button: 'Navigate to park',
      },
      general: {
        title: 'Opening the gate',
        text:
          'Arriving at the park you can open the gate with this personal code:',
        linkInfo: (...args: string[]) =>
          `View Information on ${args[0]} BestPark`,
        linkModify: 'Need to modify or cancel this reservation?',
        linkDownload: 'Download your receipt',
        add: 'Add',
      },
      services: {
        title: (...args: string[]) => `Your ${args[0]}`,
        text: (...args: string[]) =>
          `It will here have instructions where you can pick up the ${args[0]} you’ve reserved.`,
      },
      extendReservation: 'Extend reservation',
      cancelReservation: 'Cancel reservation',
      cancelledReservation: 'Cancelled reservation',
    },
    confirmation: {
      confirmed: 'Reservation confirmed.',
      not_found: 'Reservation not found.',
      pending: 'Reservation is currently pending.',
      confirmed_message: (...args: string[]) =>
        `Thank you for your reservation, we look forward on seeing you in ${args[0]}.`,
    },
    errors: {
      cancel: 'You can only cancel a reservation before 7 days.',
    },
    success: {
      cancel: 'Reservation successfully cancelled.',
    },
    receipt: {
      invoice: (...args: string[]) => `Receipt #${args[0]}`,
      header: (...args: string[]) =>
        `Thank you for your payment for reservation ${args[0]}, it has been paid in full for the amount of ${args[1]} ${args[2]}`,
      details: {
        paymentDate: 'Payment date',
        contactEmail: 'Contact email',
        chargedTo: 'Charged to',
        chargedFree: 'Charged for free',
        forReservation: 'For reservation',
      },
      breakdown: {
        park: 'Park',
        couponUsed: 'Coupon code',
        couponDiscount: (...args: string[]) => `Discount ${args[0]} ${args[1]}`,
        serviceEntry: 'Service entry',
        subtotal: 'Subtotal',
        grandTotal: 'Total (incl. VAT)',
        taxNotes: 'VAT',
        vat: (...args: string[]) => `${args[0]} ${args[1] ?? 10}%`,
      },
      businessId: 'Business ID',
    },
    extension: {
      full_title: 'Reservation extension unavailable',
      full_description: (...args: string[]) =>
        `Unfortunately, your reservation can no longer be extended for the reason that parking spot ${args[0]} on ${args[1]} is no longer available.`,
      full_description2:
        'You may want to book again for a different parking spot on our booking page.',
      book_reservation: 'Book a new reservation',
    },
  },
  promotions: {
    general: {
      read_more: 'Read more',
    },
    hotline: {
      title: 'Help 24/7',
      text: 'Our customer service is always available.',
      footer: 'The price of a call is 8,35 cent/call + 16,69 cent/minute',
    },
    infos: {
      title: 'Affect!',
      text: 'Tell us the best places and take part in the gift card draw',
      buttonText: 'To the questionaire',
    },
  },
  login: {
    header: 'Log in to your account',
    subheader: 'No account yet? ',
    registrationLink: 'Register here',
    forgetPasswordLink: 'Forgot password?',
    email: 'Email',
    password: 'Password',
    continue: 'Continue',
    authContent: 'Enter authentication code sent to ',
    errors: {
      fillRequired: 'Please fill in highlighted fields.',
      email: 'Email is invalid.',
      sessionInvalidated: 'Session has been invalidated please login again',
      invalidCode: 'Incorrect code',
    },
  },
  mail: {
    header: 'Check your phone',
    open: 'Open mail app',
    content: (...args: string[]) =>
      `We sent a login link to \n${args[0]},\n it will sign you in.`,
  },
  registration: {
    header: 'Register an account',
    subheader: 'Already have an account? ',
    registerButton: 'Register',
    success: {
      header: 'You have successfully registered.',
      content: 'You may now login to your account.',
    },
  },
  profileEdit: {
    header: 'Edit profile account',
    subheader: 'Update your account details',
    editButton: 'Edit Profile',
    success: {
      header: 'You have successfully updated your account.',
      content: 'My Account',
    },
  },
  book_category: {
    unavailable_title: (...args: string[]) =>
      `${args[0]} reservation is unavailable.`,
    unavailable_description:
      'You may want to book on the caravan booking page.',
    book_reservation: 'Book a caravan reservation',
  },
  calendar: {
    general: {
      start_reservation: 'Start reservation',
      select_check_in: 'Please select check-in date.',
      select_check_out:
        'Please select check-out date and click start reservation.',
      select_extended_check_out: 'Choose check-out date',
      extension_title: 'Extend reservation',
      extension_description:
        'You can extend the same booking for up to 7 extra nights',
      to_pay: 'Pay here',
      summary_extension: (...args: string[]) =>
        `Extending the booking by ${args[0]} ${
          parseInt(args[0]) > 1 ? 'nights' : 'night'
        } for a total of ${args[1]} ${args[2]}. New check-out by ${
          args[3]
        } at 12 noon.`,
      summary: (...args: string[]) =>
        `Reservation from ${args[0]} to ${args[1]}.\nCheck in at ${args[2]}, check out at ${args[3]}. Total price: ${args[4]} ${args[5]}.`,
      cancellation_policy:
        'Free cancellation 2 days before arrival. 50% refund when cancelled by 13:00 on the day of arrival.',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    in_months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    weeks: {
      monday: 'Mon',
      tuesday: 'Tue',
      wednesday: 'Wed',
      thursday: 'Thu',
      friday: 'Fri',
      saturday: 'Sat',
      sunday: 'Sun',
    },
  },
  parks: {
    from: 'From',
    check_advance: 'Check in advance',
    promotion: (...args: string[]) =>
      `We have ${args[0]} modern parks for summer ${args[1]}`,
    per_night: 'a night',
    listTitle: (...args: string[]) => `Summer ${args[0]} parks:`,
  },
  newsletter: {
    title: 'Sign up for our newsletter',
    subscribe: 'Subscribe',
    subscribeMsg:
      'Don’t drive by your park! Sign up for our newsletter and be the first to read the latest news about BestPark.',
    notifications: {
      subscribeSuccess: 'Thank you for getting in touch!',
      subscribeError: 'Failed to process your request. Please try again.',
    },
  },
  mediaPage: {
    visualisation: 'Visual images',
    stock: 'Stock Images',
    parkImages: 'Presentation of the premises',
  },
  contactUs: {
    billingHeader: 'Billing Information',
    businessId: 'Vat. ID',
    paymentTerm: 'Terms of payment',
    paymentTermValue: (term: string) => `${term} days`,
    invoiceAddress: 'E-invoice address',
    brokerAddress: 'Intermediaries address',
    send: 'Send',
  },
  formLabels: {
    message: 'Your message',
    name: 'Name',
    email: 'Email',
    place: 'Place',
    authCode: 'Authentication Code',
  },
  serviceEntry: {
    card: {
      header: 'Need to stop for servicing?',
      subheader1:
        'Book a pit stop for you and for your vehicle. You will receive a code that is valid for 60 minutes after entering the park.',
      subheader2: 'You can visit the park between 7 am and 10 pm.',
      cta: (...args: string[]) =>
        `Book a service break for ${args[0]} ${args[1]}`,
    },
    selectDate: {
      header: 'Select date',
      cta: 'Go to contact details',
      reminder:
        'The access code for the gate is valid for 60 minutes from activation.',
    },
    confirmation: {
      paymentProcessed: 'Successfully processed payment.',
    },
    summary: {
      buttonText: 'View service entry',
      dayInPark: 'Service pitstop',
    },
    details: {
      date: 'Service pitstop date',
      listHeader: 'Service Entries',
    },
  },
  book: {
    header: (...args: string[]) => `Make a booking to\n ${args[0]} BestPark`,
    headerCategory: (...args: string[]) =>
      `Make a ${args[0]} booking in\n ${args[1]} BestPark`,
    maintenanceHeader: (...args: string[]) =>
      `Book a maintenance to\n ${args[0]} BestPark`,
  },
};

export default en;
